/**
 * IPFS helpers.
 *
 * Tempo stores the transfer validity/range/equality proof bundle on IPFS, and the
 * on-chain `proof` calldata argument is just a UTF-8 pointer of the form:
 *     ipfs://<cid>
 *
 * The auditor dashboard resolves that pointer to the actual ABI-encoded proof bytes
 * via a configurable HTTP gateway.
 */

const DEFAULT_GATEWAY = 'https://gateway.pinata.cloud/ipfs/';

/**
 * Build a public HTTP URL for a given IPFS CID (optionally with a trailing path).
 *
 * Uses `REACT_APP_IPFS_GATEWAY` if set (with or without a trailing `/ipfs/`),
 * otherwise falls back to https://ipfs.io/ipfs/.
 *
 * @param {string} cid
 * @returns {string}
 */
export const ipfsGatewayUrlForCid = (cid) => {
  if (!cid || typeof cid !== 'string') {
    throw new Error('Invalid IPFS CID');
  }

  const trimmedCid = cid.trim().replace(/^ipfs:\/\//, '').replace(/^\/+/, '');
  if (!trimmedCid) {
    throw new Error('Invalid IPFS CID');
  }

  const rawGateway = (process.env.REACT_APP_IPFS_GATEWAY || DEFAULT_GATEWAY).trim();
  const gateway = rawGateway.endsWith('/') ? rawGateway : `${rawGateway}/`;
  const normalizedGateway = /\/ipfs\/$/.test(gateway) ? gateway : `${gateway}ipfs/`;

  return `${normalizedGateway}${trimmedCid}`;
};
